// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2317S","navbar":"styles_navbar__3sYAR"};